var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgErrorIcon = function SvgErrorIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 0C17.4562 0 0 17.4562 0 39C0 60.5438 17.4562 78 39 78C60.5438 78 78 60.5438 78 39C78 17.4562 60.5438 0 39 0ZM42.225 20.55L41.6438 42.1313C41.6063 43.6688 40.5375 44.9062 39 44.9062C37.4625 44.9062 36.3937 43.6688 36.3562 42.1313L35.775 20.55C35.7375 18.75 37.1813 17.25 39 17.25C40.8 17.25 42.2625 18.7313 42.225 20.55ZM39 57.375C36.9938 57.375 35.4187 55.8563 35.4187 53.925C35.4187 51.9938 36.9938 50.475 39 50.475C41.0062 50.475 42.5813 51.9938 42.5813 53.925C42.5813 55.8563 41.0062 57.375 39 57.375Z",
    fill: "#F9DA87"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgErrorIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error_icon.d8445bb6dabafb00b55e38e14bbfece6.svg";